module.exports = function (storePickerPanelService, globalHeaderPanelService, storePickerService, atm, breakpointsService, $state, $timeout) {
    return {
        restrict: 'E',
        scope: {
        },
        link(scope) {
            let isNotificationShown = false;

            scope.storePicker = storePickerService;
            scope.showSetStore = false;

            scope.$watch('storePicker.fulfilmentInfo.IsSystemAddress', function (val, oldVal) {
                if (val
                    && val !== oldVal
                    && !isNotificationShown
                    && (!$state.previous || ($state.previous.route.name !== 'checkout' && $state.previous.route.name !== 'checkout.checkoutLogin'))
                    && !$state.includes('shop.authentication.signup')
                    && breakpointsService.isInSmallFormat
                ) {
                    scope.showSetStore = true;
                    isNotificationShown = true;
                }

            }, true);

            $timeout(function () {
                if (scope.showSetStore) {
                    const fulfilmentInfo = scope.storePicker.fulfilmentInfo;

                    const atmData = {
                        event: 'BWSAUupdateStorePreferenceShareLocationBanner',
                        store: {
                            LocationBannerInteraction: 'view'
                        },
                        fulfilmentInfo
                    };

                    atm.pushWithStoreMapper(atmData);
                }
            });

            scope.closeSetStoreNotificationBanner = function () {
                const fulfilmentInfo = scope.storePicker.fulfilmentInfo;

                const atmData = {
                    event: 'BWSAUupdateStorePreferenceShareLocationBanner',
                    store: {
                        LocationBannerInteraction: 'close'
                    },
                    fulfilmentInfo
                };

                atm.pushWithStoreMapper(atmData);

                scope.closeSetStoreNotification();
            };

            scope.closeSetStoreNotification = function () {
                scope.showSetStore = false;
            };

            scope.$on('$stateChangeStart', function () {
                scope.closeSetStoreNotification();
            });

            scope.openStorePicker = function () {
                storePickerPanelService.open();

                if (storePickerService.fulfilmentInfo.IsSystemAddress || storePickerService.fulfilmentMethod === 'Delivery') {
                    storePickerPanelService.changeStoreView = true;
                }

                globalHeaderPanelService.closePanel();

                const fulfilmentInfo = scope.storePicker.fulfilmentInfo;

                const atmData = {
                    event: 'BWSAUupdateStorePreferenceShareLocationBanner',
                    store: {
                        LocationBannerInteraction: 'click'
                    },
                    fulfilmentInfo
                };

                atm.pushWithStoreMapper(atmData);

                scope.closeSetStoreNotification();
            };
        },
        template: require('./mobile-set-store-notification-template.html').trim()
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/mobile-set-store-notification/mobile-set-store-notification-directive.js
 **/